module.exports = __webpack_public_path__ + "img/form-cafe.5ed11cab.png";